import React from "react";
import Devices  from "../modules/DevicesReport/Devices";
export default function DevicesReportPage() {
  return <Devices />;
}
